import { NdSklad } from '../../ndSklad';

export { DMS_MODULE, MODULE_API } from '../../constants';
export const NAME = <const>'PRReturnPolozky';
export const CRUMB_LABEL_KEY = 'edtPRReturn';
export const ND_SKLAD = NdSklad.name;
